import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import "../../../../src/content/birmingham-city-buses/birmingham-buses.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  React
};